/**
 * Render a gateway error frame as one line for the UI.
 *
 * Validation failures (config.patch) carry the offending paths in
 * `details.issues`; dropping them left the user with a bare "invalid config"
 * and no way to tell what the form got wrong.
 */

const MAX_ISSUES = 3;

type RpcError = { code?: string; message?: string; details?: unknown };

type Issue = { path?: unknown; message?: unknown };

function issueList(details: unknown): Issue[] {
  if (!details || typeof details !== "object") {return [];}
  const issues = (details as { issues?: unknown }).issues;
  return Array.isArray(issues) ? (issues as Issue[]) : [];
}

function formatIssue(issue: Issue): string {
  const path = typeof issue.path === "string" ? issue.path : Array.isArray(issue.path) ? issue.path.join(".") : "";
  const message = typeof issue.message === "string" ? issue.message : "";
  if (path && message) {return `${path}: ${message}`;}
  return path || message;
}

export function formatRpcError(error: RpcError | undefined): string {
  const message = error?.message?.trim() || "request failed";
  const issues = issueList(error?.details).map(formatIssue).filter(Boolean);
  if (issues.length === 0) {return message;}
  const shown = issues.slice(0, MAX_ISSUES);
  const rest = issues.length - shown.length;
  return `${message} — ${shown.join("; ")}${rest > 0 ? ` (+${rest} more)` : ""}`;
}
